import { render, staticRenderFns } from "./datasource.vue?vue&type=template&id=c853c04a&scoped=true"
import script from "./datasource.vue?vue&type=script&lang=js"
export * from "./datasource.vue?vue&type=script&lang=js"
import style0 from "./datasource.vue?vue&type=style&index=0&id=c853c04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c853c04a",
  null
  
)

export default component.exports